module.exports = __webpack_public_path__ + "static/media/portfolio-rebal.c11ad176.svg";